<template>
  <section class="search-and-view bg-pink">
    <div class="search-wrapper"  :style="searchBarWidth">
      <input
        type="search"
        v-model="message"
        name=""
        id=""
        class="fs-4"
        placeholder="Search offers (by merchant name)"
        @input="inputChanged"
        @keyup.enter="passEvent"
      />
      <button class="icon-search" @click="passEvent"></button>
    </div>
    <button class="list-view" @click="showView('list')"></button>
    <button v-show="!hideMapButton" class="map-view" @click="showView('map')"></button>
  </section>
</template>

<script>
export default {
  name: "SearchViewComponent",
    props: ['hideMapButton', 'messageValue'],

  data() {
    return {
      message: this.messageValue || '',
      searchBarWidth: this.hideMapButton ? 'width:96%' : 'width:92%'
    };
  },

    mounted() {
      // console.log(this.messageValue, 'search');
    },

    watch: {
        messageValue: function (val) {
           if(val) {
               this.message = val
           }
        }
    },

    methods: {
    passEvent() {
      this.$emit("onChange", this.message);
    },
      inputChanged() {
      this.$emit("inputChanged", this.message);
    },
    showView(view) {
      this.$emit("showView", view);
    },
  },
};
</script>
